export default __webpack_public_path__ + "static/media/bruno-fernandes-embassador.1da05a81.jpg";